/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentMeta
 */
export interface TournamentMeta {
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    creator?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentMeta
     */
    creationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TournamentMeta
     */
    description?: string;
}

/**
 * Check if a given object implements the TournamentMeta interface.
 */
export function instanceOfTournamentMeta(value: object): value is TournamentMeta {
    return true;
}

export function TournamentMetaFromJSON(json: any): TournamentMeta {
    return TournamentMetaFromJSONTyped(json, false);
}

export function TournamentMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'creator': json['creator'] == null ? undefined : json['creator'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TournamentMetaToJSON(json: any): TournamentMeta {
    return TournamentMetaToJSONTyped(json, false);
}

export function TournamentMetaToJSONTyped(value?: TournamentMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'creator': value['creator'],
        'creationDate': value['creationDate'] == null ? value['creationDate'] : value['creationDate'].toISOString(),
        'description': value['description'],
    };
}

